import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const Button = ({ children, onClick, disabled, className, style }) => {
  const buttonClassNames = classNames('button', {
    'button--disabled': disabled
  }, className);

  const handleClick = (e) => {
    if (!disabled) onClick(e);
  };

  return (
    <button
      type="button"
      className={buttonClassNames}
      onClick={handleClick}
      disabled={disabled}
      style={style}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object
};

Button.defaultProps = {
  onClick: () => {}
};

export default Button;
